/**
*
* Recebe os ddis ( inbound/ outbound ) da campanha e escolhe o que for wnviado no workflow
* Se não for enviado workflow, por defeito avalia primeiro se tem no inbound e depois
* no outbound caso o inbound seja null
* @param {Object} ddis - objeto de ddis contendo as keys inbound e outbound
* @param {String} string - tipo de workflow ( inbound/ outbound )
* @return {Object} - ddi pretendido
*
*/
const getDdi = ({ ddis, workflow }) => {
    if ( [ 'inbound', 'outbound' ].includes( workflow?.toLowerCase() ) )
        return ddis[workflow];

    return ddis.inbound || ddis.outbound;
};

export default getDdi;